import React, { Component } from 'react';
import { array, arrayOf, bool, func, number, object, string } from 'prop-types';
import { FormattedMessage, injectIntl, intlShape } from '../../util/reactIntl';
import classNames from 'classnames';
import ReactTooltip from 'react-tooltip';
import { withRouter } from 'react-router-dom';
import { BsBellFill } from 'react-icons/bs';
import {
  TRANSITION_RELEASE_FUNDS,
  TRANSITION_REVIEW_1_BY_PROVIDER,
  TRANSITION_REVIEW_1_BY_CUSTOMER,
  TRANSITION_REVIEW_2_BY_PROVIDER,
  TRANSITION_REVIEW_2_BY_CUSTOMER,
  TRANSITION_REQUEST_PAYMENT_AFTER_ENQUIRY,
  TRANSITION_MAKE_PROJECT_BID,
  TRANSITION_MAKE_PROJECT_BID_AFTER_ENQUIRY,
  TRANSITION_ACCEPT_OFFER,
  TRANSITION_DECLINE_OFFER,
  TRANSITION_EXPIRE_OFFER,
  TRANSITION_CONFIRM_PAYMENT,
  TRANSITION_JOB_DONE,
  TRANSITION_JOB_DONE_RELEASE_FUNDS,
  TRANSITION_JOB_DONE_CUSTOMER,
  TRANSITION_MAKE_CUSTOM_OFFER,
  TRANSITION_MAKE_CUSTOM_PRO_OFFER,
  TRANSITION_ACCEPT_CUSTOM_PRO_OFFER,
  TRANSITION_JOB_DONE_PRO,
  TRANSITION_JOB_ACCEPTED,
  TRANSITION_SKIP_TO_REVIEWS,
  TRANSITION_ACCEPT_CUSTOM_OFFER_INVOICE,
  TRANSITION_JOB_DONE_INVOICE,
  TRANSITION_ACCEPT_JOB_INVOICE,
  TRANSITION_JOB_DONE_ACCEPT_INVOICE,
  txUsesInvoicePath,
  txIsLegacyProProcess,
  txIsEnquired,
  txIsReviewed,
  txIsInFirstReviewBy,
  txRoleIsCustomer,
  txIsDelivered,
  txLastTransition,
  txIsCanceled,
  txIsDeclined,
  txIsPaymentExpired,
  txIsPaymentPending,
  txIsRequested,
  txHasBeenDelivered,
  txIsProReadyAccepted,
  txIsProAccepted,
  txIsAccepted,
} from '../../util/transaction';
import { LINE_ITEM_NIGHT, LINE_ITEM_DAY, propTypes } from '../../util/types';
import {
  ensureListing,
  ensureTransaction,
  ensureUser,
  userDisplayNameAsString,
} from '../../util/data';
import { formatMoney } from '../../util/currency';
import {
  NamedLink,
  ReviewModal,
  UserDisplayName,
  Modal,
  PrimaryButton,
  SecondaryButton,
  NeedHelpInfo,
  NamedRedirect,
} from '../../components';
import {
  SendMessageForm,
  CustomOfferForm,
  ProjectBidForm,
  CustomOfferAcceptedForm,
} from '../../forms';
import config from '../../config';
import { types as sdkTypes } from '../../util/sdkLoader';
import { createSlug } from '../../util/urlHelpers';
import { isActionNeeded } from '../../util/processStepHelper';

import { ATTACHMENTS_ONLY_MESSAGE } from '../ActivityFeed/ActivityFeed';
import FeedSection from './FeedSection';
import SaleActionButtonsMaybe from './SaleActionButtonsMaybe';
import ProjectActionButtonsMaybe from './ProjectActionButtonsMaybe';
import CustomOfferModal from './CustomOfferModal';
import RequestInvoicingModal from './RequestInvoicingModal';
import InvoiceInfoModal from './InvoiceInfoModal';
import ApplicationBanner from './ApplicationBanner';
import ApplicationModal from './ApplicationModal';
import ProviderOnboardingRequiredModal from './ProviderOnboardingRequiredModal';
import { isStripeAccountComplete, offerStripeGateStatus } from '../../util/stripeHelpers';
import CustomOfferStripeGate from './CustomOfferStripeGate';
import { vatDeclared, vatStatusReminder, offerTotals, resolutionForOffer } from '../../util/vat';
import { billingInitialValuesForUser } from '../../forms/BillingDetailsForm/BillingDetailsForm';
import {
  isInvoiceBilledCustomer,
  invoiceOptionState,
  billingLockedFields,
  INVOICE_PAYMENT_TERM_DAYS,
} from '../../util/invoicing';
import {
  customOfferDataFromTransaction,
  offerAttachmentsSupported,
  offerAttachments,
} from '../../util/customOffer';
import {
  readyAttachmentFileIds,
  stagedEntriesFromAttachments,
} from '../../ducks/messageAttachments.duck';
import FreelancerOnboardingBanner from '../FreelancerOnboardingBanner/FreelancerOnboardingBanner';
import FreelancerOnboardingModal from '../FreelancerOnboardingModal/FreelancerOnboardingModal';
import VatStatusBanner from '../VatStatusBanner/VatStatusBanner';
import PanelHeading, {
  HEADING_ENQUIRED,
  HEADING_PAYMENT_PENDING,
  HEADING_PAYMENT_EXPIRED,
  HEADING_REQUESTED,
  HEADING_ACCEPTED,
  HEADING_DECLINED,
  HEADING_CANCELED,
  HEADING_DELIVERED,
  HEADING_OFFER_MADE,
  HEADING_OFFER_ACCEPTED,
  HEADING_OFFER_DECLINED,
  HEADING_JOB_DONE,
  HEADING_JOB_DONE_CUSTOMER,
  HEADING_JOB_ACCEPTED,
} from './PanelHeading';

import css from './TransactionPanel.css';
import { createResourceLocatorString } from '../../util/routes';
import routeConfiguration from '../../routeConfiguration';

import ProcessStepsCard from './ProcessStepsCard';

const { Money } = sdkTypes;

// Helper function to get display names for different roles
const displayNames = (currentUser, currentProvider, currentCustomer, intl) => {
  const authorDisplayName = <UserDisplayName user={currentProvider} intl={intl} />;
  const customerDisplayName = <UserDisplayName user={currentCustomer} intl={intl} />;

  let otherUserDisplayName = '';
  let otherUserDisplayNameString = '';
  const currentUserIsCustomer =
    currentUser.id && currentCustomer.id && currentUser.id.uuid === currentCustomer.id.uuid;
  const currentUserIsProvider =
    currentUser.id && currentProvider.id && currentUser.id.uuid === currentProvider.id.uuid;

  if (currentUserIsCustomer) {
    otherUserDisplayName = authorDisplayName;
    otherUserDisplayNameString = userDisplayNameAsString(currentProvider, '');
  } else if (currentUserIsProvider) {
    otherUserDisplayName = customerDisplayName;
    otherUserDisplayNameString = userDisplayNameAsString(currentCustomer, '');
  }

  return {
    authorDisplayName,
    customerDisplayName,
    otherUserDisplayName,
    otherUserDisplayNameString,
  };
};

const shouldOpenReviewModal = (transactionRole, transaction) => {
  const isCustomer = txRoleIsCustomer(transactionRole);
  const currentTransition = txLastTransition(transaction);

  switch (currentTransition) {
    case TRANSITION_RELEASE_FUNDS:
    case TRANSITION_JOB_DONE_RELEASE_FUNDS:
      return txIsDelivered(transaction);
    case TRANSITION_REVIEW_1_BY_PROVIDER:
    case TRANSITION_REVIEW_1_BY_CUSTOMER:
      const reviewPeriodIsOver = txIsReviewed(transaction);
      const userHasLeftAReview = txIsInFirstReviewBy(transaction, isCustomer);
      return !(reviewPeriodIsOver || userHasLeftAReview);
    case TRANSITION_SKIP_TO_REVIEWS:
      return txIsProReadyAccepted(transaction);
    case TRANSITION_JOB_ACCEPTED:
      return txIsProReadyAccepted(transaction);
    default:
      return false;
  }
};

// A custom offer awaiting the customer's answer (CustomOfferModal's isPending)
// that the VAT preview applies to. Legacy pro offers accept through a
// non-privileged transition that never resolves VAT, so they are not
// previewed (R39).
const PENDING_OFFER_TRANSITIONS = [TRANSITION_MAKE_CUSTOM_OFFER, TRANSITION_MAKE_CUSTOM_PRO_OFFER];
const hasPendingCustomOffer = transaction =>
  !!(
    transaction &&
    transaction.attributes &&
    transaction.attributes.processName !== 'flex-pro-process' &&
    customOfferDataFromTransaction(transaction) &&
    PENDING_OFFER_TRANSITIONS.includes(transaction.attributes.lastTransition)
  );

export class TransactionPanelComponent extends Component {
  constructor(props) {
    const { projectBidModalOpenForTransactionId, transactionRole, transaction } = props;

    super(props);
    this.state = {
      sendMessageFormFocused: false,
      isReviewModalOpen: shouldOpenReviewModal(transactionRole, transaction),
      reviewSubmitted: false,
      projectBidModalOpen: projectBidModalOpenForTransactionId === props.transaction.id,
      newEnquiryModalOpen: false,
      newProjectEnquiryModalOpen: false,
      customOfferModalOpen: false,
      // 'checking' | 'blocked' | 'open': the freelancer's Stripe account
      // must be able to take the customer's card payment before an offer.
      offerStripeStatus: 'open',
      isUpdatingCustomOffer: false,
      customOfferFormSession: 0,
      // Form key the staged offer attachments were last seeded for; see
      // customOfferDraftKey().
      offerAttachmentsDraftKey: null,
      acceptCustomOfferModalOpen: false,
      requestInvoicingModalOpen: false,
      txInfoOpen: true,
      workCompleteModalOpen: false,
      pendingWorkHandler: null,
      releaseFundsModalOpen: false,
      pendingReleaseFundsHandler: null,
      acceptProJobModalOpen: false,
      pendingAcceptProJobHandler: null,
      freelancerOnboardingModalOpen: false,
      freelancerOnboardingBannerClosed: false,
      invoiceInfoModalOpen: false,
      applicationModalOpen: false,
      vatBannerClosed: false,
    };
    this.isMobSaf = false;
    this.sendMessageFormName = 'TransactionPanel.SendMessageForm';

    this.onOpenReviewModal = this.onOpenReviewModal.bind(this);
    this.onSubmitReview = this.onSubmitReview.bind(this);
    this.onSendMessageFormFocus = this.onSendMessageFormFocus.bind(this);
    this.onSendMessageFormBlur = this.onSendMessageFormBlur.bind(this);
    this.onMessageSubmit = this.onMessageSubmit.bind(this);
    this.scrollToMessage = this.scrollToMessage.bind(this);
    this.handleSendCustomOffer = this.handleSendCustomOffer.bind(this);
    this.handleAcceptCustomOffer = this.handleAcceptCustomOffer.bind(this);
    this.openCustomOfferModal = this.openCustomOfferModal.bind(this);
    this.closeCustomOfferModal = this.closeCustomOfferModal.bind(this);
    this.onProjectBid = this.onProjectBid.bind(this);
    this.onSubmitProjectBid = this.onSubmitProjectBid.bind(this);
    this.handleWorkCompleteWithConfirm = this.handleWorkCompleteWithConfirm.bind(this);
    this.confirmWorkComplete = this.confirmWorkComplete.bind(this);
    this.cancelWorkComplete = this.cancelWorkComplete.bind(this);
    this.handleReleaseFundsWithConfirm = this.handleReleaseFundsWithConfirm.bind(this);
    this.confirmReleaseFunds = this.confirmReleaseFunds.bind(this);
    this.cancelReleaseFunds = this.cancelReleaseFunds.bind(this);
    this.handleAcceptProJobWithConfirm = this.handleAcceptProJobWithConfirm.bind(this);
    this.confirmAcceptProJob = this.confirmAcceptProJob.bind(this);
    this.cancelAcceptProJob = this.cancelAcceptProJob.bind(this);
    this.handleOpenFreelancerOnboarding = this.handleOpenFreelancerOnboarding.bind(this);
    this.handleCloseFreelancerOnboarding = this.handleCloseFreelancerOnboarding.bind(this);
    this.handleDismissFreelancerOnboarding = this.handleDismissFreelancerOnboarding.bind(this);
    this.handleCloseBanner = this.handleCloseBanner.bind(this);
    this.onOpenApplicationModal = this.onOpenApplicationModal.bind(this);
    this.onCloseApplicationModal = this.onCloseApplicationModal.bind(this);
    this.fetchVatPreview = this.fetchVatPreview.bind(this);
    this.handleOfferStripeAccountLink = this.handleOfferStripeAccountLink.bind(this);
  }

  componentDidMount() {
    this.mounted = true;
    if (typeof window !== 'undefined') {
      window.Intercom('update', { hide_default_launcher: true });
    }
    if (hasPendingCustomOffer(this.props.transaction)) {
      this.fetchVatPreview(null);
    }
  }

  componentDidUpdate(prevProps, prevState) {
    // The provider's offer form prices the offer from the preview. The
    // customer's accept modal fetches its own on open, for the payment
    // method it has selected (R35).
    const offerFormOpened = this.state.customOfferModalOpen && !prevState.customOfferModalOpen;
    // The offer card and process steps price a pending offer from the
    // preview too, so fetch it whenever the page shows one.
    const tx = this.props.transaction;
    const prevTx = prevProps.transaction;
    const txChanged =
      (tx && tx.id && tx.id.uuid) !== (prevTx && prevTx.id && prevTx.id.uuid) ||
      (tx && tx.attributes && tx.attributes.lastTransition) !==
        (prevTx && prevTx.attributes && prevTx.attributes.lastTransition);
    if (offerFormOpened || (txChanged && hasPendingCustomOffer(tx))) {
      this.fetchVatPreview(null);
    }
  }

  fetchVatPreview(paymentMethod) {
    const { onFetchVatPreview, transaction } = this.props;
    if (onFetchVatPreview && transaction && transaction.id) {
      onFetchVatPreview(transaction.id, paymentMethod === 'invoice' ? 'invoice' : null).catch(
        () => null
      );
    }
  }

  componentWillUnmount() {
    this.mounted = false;
    if (typeof window !== 'undefined') {
      window.Intercom('update', { hide_default_launcher: false });
    }
  }

  // Before a (new or updated) offer, check that the freelancer's Stripe
  // account can take the customer's card payment; the modal shows the
  // "finish your Stripe account" box instead of the form when it can't.
  checkOfferStripeAccount() {
    const { currentUser, stripeAccount, transactionRole, onFetchStripeAccount } = this.props;
    const accountRole = currentUser?.attributes?.profile?.publicData?.account_role;
    const requiresStripe = transactionRole === 'provider' && accountRole !== 'light-entrepreneur';
    const hasStripeAccount = isStripeAccountComplete(stripeAccount);
    this.setState({
      offerStripeStatus:
        requiresStripe && hasStripeAccount && onFetchStripeAccount ? 'checking' : 'open',
    });
    offerStripeGateStatus({
      requiresStripe: requiresStripe && !!onFetchStripeAccount,
      hasStripeAccount,
      fetchStripeAccount: onFetchStripeAccount,
    }).then(offerStripeStatus => {
      if (this.mounted) this.setState({ offerStripeStatus });
    });
  }

  // Stripe's onboarding, returning to this conversation so the offer can be
  // made right after.
  handleOfferStripeAccountLink() {
    const { transaction, onGetStripeConnectAccountLink } = this.props;
    if (!onGetStripeConnectAccountLink || !transaction) return;
    const path = createResourceLocatorString(
      'SaleDetailsPage',
      routeConfiguration(),
      { id: transaction.id.uuid },
      {}
    );
    const returnURL = `${config.canonicalRootURL.replace(/\/$/, '')}${path}`;
    onGetStripeConnectAccountLink({
      type: 'custom_account_verification',
      successURL: returnURL,
      failureURL: returnURL,
    })
      .then(url => {
        window.location.href = url;
      })
      .catch(() => null);
  }

  onOpenReviewModal() {
    this.setState({ isReviewModalOpen: true });
  }

  onSubmitReview(values) {
    const { onSendReview, transaction, transactionRole } = this.props;
    const currentTransaction = ensureTransaction(transaction);
    const { reviewRating, reviewContent } = values;
    const rating = Number.parseInt(reviewRating, 10);
    onSendReview(transactionRole, currentTransaction, rating, reviewContent)
      .then(r => this.setState({ isReviewModalOpen: false, reviewSubmitted: true }))
      .catch(e => {
        // Do nothing.
      });
  }

  onSendMessageFormFocus() {
    this.setState({ sendMessageFormFocused: true });
    if (this.isMobSaf) {
      // Scroll to bottom
      window.scroll({ top: document.body.scrollHeight, left: 0, behavior: 'smooth' });
    }
  }

  onSendMessageFormBlur() {
    this.setState({ sendMessageFormFocused: false });
  }

  onMessageSubmit(values, form) {
    const message = values.message ? values.message.trim() : null;
    const { transaction, onSendMessage, stagedAttachments } = this.props;
    const ensuredTransaction = ensureTransaction(transaction);

    const readyAttachments = (stagedAttachments || []).filter(
      a => a.fileId && (a.state === 'pendingVerification' || a.state === 'available')
    );
    const fileIds = readyAttachments.map(a => a.fileId);

    if (!message && fileIds.length === 0) {
      return;
    }

    // Sharetribe requires non-empty message content (1-5000 chars). Attachment-only
    // messages store a placeholder token that the activity feed renders as a
    // localized "Attachments" label in each viewer's own locale.
    const content = message || ATTACHMENTS_ONLY_MESSAGE;

    onSendMessage(ensuredTransaction.id, content, fileIds)
      .then(messageId => {
        form.reset();
        this.scrollToMessage(messageId);
      })
      .catch(e => {
        // Ignore, Redux handles the error
      });
  }

  scrollToMessage(messageId) {
    const selector = `#msg-${messageId.uuid}`;
    const el = document.querySelector(selector);
    if (el) {
      el.scrollIntoView({
        block: 'end',
        behavior: 'smooth',
      });
    }
  }

  // Identifies one offer draft: the form instance (a new one after each send)
  // on this transaction. The staged set lives in a single global scope, so the
  // transaction id keeps a draft from following the user to another thread.
  customOfferDraftKey() {
    return `${this.props.transaction.id.uuid}-${this.state.customOfferFormSession}`;
  }

  // The first open of a draft decides what the "Liitteet" block starts with:
  // an update edits the files already on the offer, a new offer starts empty.
  // Reopening the same draft keeps the files staged so far, like its fields.
  openCustomOfferModal(isUpdating) {
    const { transaction, onSeedOfferAttachments, onClearOfferAttachments } = this.props;
    const draftKey = this.customOfferDraftKey();
    if (this.state.offerAttachmentsDraftKey !== draftKey) {
      if (isUpdating) {
        onSeedOfferAttachments(stagedEntriesFromAttachments(offerAttachments(transaction)));
      } else {
        onClearOfferAttachments();
      }
    }
    this.checkOfferStripeAccount();
    this.setState({
      customOfferModalOpen: true,
      isUpdatingCustomOffer: isUpdating,
      offerAttachmentsDraftKey: draftKey,
    });
  }

  // Closing without sending keeps the draft (fields and staged files) for the
  // next open; the form stays mounted inside the closed modal.
  closeCustomOfferModal() {
    this.setState({ customOfferModalOpen: false });
  }

  handleSendCustomOffer(values) {
    const { title, description, customOfferAmount, startDate, deliveryDate } = values;
    const {
      onSendCustomOffer,
      transaction,
      intl,
      offerStagedAttachments,
      nextTransitions,
    } = this.props;
    // Only the retired pro process has make-custom-pro-offer; default and
    // light always take make-custom-offer, whatever the customer's billing.
    const isProProcess = txIsLegacyProProcess(transaction);
    // Only a process running update-protected-files takes the file set; on
    // older versions the parameter must not be sent at all.
    const fileIds = offerAttachmentsSupported(nextTransitions)
      ? readyAttachmentFileIds(offerStagedAttachments || [])
      : undefined;
    onSendCustomOffer(
      transaction.id.uuid,
      { title, description, customOfferAmount, startDate, deliveryDate, isProProcess, fileIds },
      intl
    )
      .then(() => {
        // A sent offer starts the next edit from a fresh form (new key), seeded
        // from the offer just saved. Closing without sending keeps the form.
        this.setState(prevState => ({
          customOfferModalOpen: false,
          customOfferFormSession: prevState.customOfferFormSession + 1,
        }));
      })
      .catch(() => {
        // Ignore, error handling in duck file
      });
  }

  handleWorkCompleteWithConfirm(handler) {
    this.setState({
      workCompleteModalOpen: true,
      pendingWorkHandler: handler,
    });
  }

  confirmWorkComplete() {
    const { pendingWorkHandler } = this.state;
    this.setState({
      workCompleteModalOpen: false,
      pendingWorkHandler: null,
    });
    if (pendingWorkHandler) {
      pendingWorkHandler();
    }
  }

  cancelWorkComplete() {
    this.setState({
      workCompleteModalOpen: false,
      pendingWorkHandler: null,
    });
  }

  handleReleaseFundsWithConfirm(handler) {
    const {
      acceptInProgress,
      declineInProgress,
      releaseFundsInProgress,
      jobDoneReleaseFundsInProgress,
    } = this.props;

    // Don't open modal if action already in progress
    if (
      acceptInProgress ||
      declineInProgress ||
      releaseFundsInProgress ||
      jobDoneReleaseFundsInProgress
    ) {
      return;
    }

    this.setState({
      releaseFundsModalOpen: true,
      pendingReleaseFundsHandler: handler,
    });
  }

  confirmReleaseFunds() {
    const { pendingReleaseFundsHandler } = this.state;
    const {
      acceptInProgress,
      declineInProgress,
      releaseFundsInProgress,
      jobDoneReleaseFundsInProgress,
    } = this.props;

    // Prevent execution if already in progress
    if (
      acceptInProgress ||
      declineInProgress ||
      releaseFundsInProgress ||
      jobDoneReleaseFundsInProgress
    ) {
      return;
    }

    this.setState({
      releaseFundsModalOpen: false,
      pendingReleaseFundsHandler: null,
    });
    if (pendingReleaseFundsHandler) {
      pendingReleaseFundsHandler();
    }
  }

  cancelReleaseFunds() {
    this.setState({
      releaseFundsModalOpen: false,
      pendingReleaseFundsHandler: null,
    });
  }

  handleAcceptProJobWithConfirm(handler) {
    const { acceptInProgress, declineInProgress } = this.props;

    // Don't open modal if action already in progress
    if (acceptInProgress || declineInProgress) {
      return;
    }

    this.setState({
      acceptProJobModalOpen: true,
      pendingAcceptProJobHandler: handler,
    });
  }

  confirmAcceptProJob() {
    const { pendingAcceptProJobHandler } = this.state;
    const { acceptInProgress, declineInProgress } = this.props;

    // Prevent execution if already in progress
    if (acceptInProgress || declineInProgress) {
      return;
    }

    this.setState({
      acceptProJobModalOpen: false,
      pendingAcceptProJobHandler: null,
    });
    if (pendingAcceptProJobHandler) {
      pendingAcceptProJobHandler();
    }
  }

  cancelAcceptProJob() {
    this.setState({
      acceptProJobModalOpen: false,
      pendingAcceptProJobHandler: null,
    });
  }

  handleOpenFreelancerOnboarding() {
    this.setState({ freelancerOnboardingModalOpen: true });
  }

  handleCloseFreelancerOnboarding() {
    this.setState({ freelancerOnboardingModalOpen: false });
  }

  handleDismissFreelancerOnboarding() {
    const { onUpdateProfile, currentUser } = this.props;
    if (onUpdateProfile && currentUser) {
      const publicData = currentUser.attributes.profile.publicData || {};
      onUpdateProfile({
        publicData: {
          ...publicData,
          hideFreelancerOnboardingTip: true,
        },
      });
    }
  }

  handleCloseBanner() {
    this.setState({ freelancerOnboardingBannerClosed: true });
  }

  onOpenApplicationModal() {
    this.setState({ applicationModalOpen: true });
  }

  onCloseApplicationModal() {
    this.setState({ applicationModalOpen: false });
  }

  handleAcceptCustomOffer(paymentMethod = 'card') {
    const currentTransaction = ensureTransaction(this.props.transaction);
    const currentListing = ensureListing(currentTransaction.listing);
    const currentProvider = ensureUser(currentTransaction.provider);

    if (typeof window === 'object') {
      window.dataLayer.push({
        event: 'add_to_cart',
        ecommerce: {
          items: [
            {
              item_name: currentListing.attributes.title,
              item_id: currentListing.id.uuid,
              price: '' + this.props.transaction.attributes.protectedData.customOfferAmount / 100,
              item_brand: currentProvider.attributes.profile.displayName,
              item_category: currentListing.attributes.publicData.category,
              item_variant: 'custom_offer',
              item_list_name: 'chat_window',
              custom_offer: 'true',
              custom_offer_value:
                '' + this.props.transaction.attributes.protectedData.customOfferAmount / 100,
              quantity: '1',
            },
          ],
        },
      });
    }

    this.props
      .onSubmitBookingRequest({
        pricingPackage: 'package1',
        suggestedPrice: new Money(
          this.props.transaction.attributes.protectedData.customOfferAmount,
          'EUR'
        ),
        isCustomOffer: true,
        skipAddToCartEvent: true,
        paymentMethod,
      })
      .then(() => {
        this.setState({ acceptCustomOfferModalOpen: false });
      })
      .catch(() => {
        // Ignore, error handling in duck file
      });
  }

  onProjectBid() {
    const {
      currentUser,
      history,
      callSetInitialValues,
      setInitialValues,
      location,
      transaction,
    } = this.props;

    if (!currentUser) {
      const state = { from: `${location.pathname}${location.search}${location.hash}` };

      // We need to log in before showing the modal, but first we need to ensure
      // that modal does open when user is redirected back to this listingpage
      callSetInitialValues(setInitialValues, {
        projectBidModalOpenForTransactionId: transaction.id,
      });

      // signup and return back to listingPage.
      history.push(createResourceLocatorString('SignupPage', routeConfiguration(), {}, {}), state);
    } else {
      this.setState({ projectBidModalOpen: true }, () => {
        ReactTooltip.rebuild();
      });
    }
  }

  onSubmitProjectBid(values) {
    const currentTransaction = ensureTransaction(this.props.transaction);
    const currentListing = ensureListing(currentTransaction.listing);
    const { history, onSendProjectBid } = this.props;
    const routes = routeConfiguration();
    const { description, amount, deliveryDate } = values;

    onSendProjectBid(
      currentListing.id,
      currentTransaction.id,
      description,
      amount.amount,
      this.props.intl,
      deliveryDate
    )
      .then(txId => {
        this.setState({ projectBidModalOpen: false });

        // Redirect to OrderDetailsPage
        history.push(
          createResourceLocatorString('OrderDetailsPage', routes, { id: txId.uuid }, {})
        );
      })
      .catch(() => {
        // Ignore, error handling in duck file
      });
  }

  render() {
    const {
      rootClassName,
      className,
      currentUser,
      transaction,
      totalMessagePages,
      oldestMessagePageFetched,
      messages,
      initialMessageFailed,
      savePaymentMethodFailed,
      fetchMessagesInProgress,
      fetchMessagesError,
      sendMessageInProgress,
      sendMessageError,
      onUploadAttachment,
      onRemoveAttachment,
      onDownloadAttachment,
      onOpenAttachment,
      onFetchAttachmentPreview,
      attachmentPreviewUrls,
      stagedAttachments,
      offerStagedAttachments,
      onUploadOfferAttachment,
      onRemoveOfferAttachment,
      downloadAttachmentInProgressIds,
      downloadAttachmentError,
      onDownloadReceipt,
      downloadReceiptInProgressId,
      downloadReceiptFailedId,
      sendReviewInProgress,
      sendReviewError,
      onManageDisableScrolling,
      onShowMoreMessages,
      transactionRole,
      intl,
      onAcceptSale,
      onJobReady,
      onJobReadyCustomer,
      onJobReadyPro,
      onAcceptProJob,
      acceptOfferInvoiceInProgress,
      acceptOfferInvoiceError,
      acceptCustomProOfferError,
      onJobDoneInvoice,
      onAcceptJobInvoice,
      onJobDoneAcceptInvoice,
      onDeclineSale,
      acceptInProgress,
      declineInProgress,
      acceptSaleError,
      declineSaleError,
      onSubmitBookingRequest,
      timeSlots,
      fetchTimeSlotsError,
      nextTransitions,
      onFetchTransactionLineItems,
      lineItems,
      fetchLineItemsInProgress,
      fetchLineItemsError,
      onReleaseFunds,
      releaseFundsInProgress,
      releaseFundsError,
      sendCustomOfferInProgress,
      sendCustomOfferError,
      onDeclineProjectBid,
      declineProjectBidInProgress,
      declineProjectBidError,
      sendProjectBidInProgress,
      sendEnquiryInProgress,
      sendProjectBidError,
      onSubmitAcceptBidRequest,
      showProfileListingInProgress,
      showProfileListingError,
      projectTransaction,
      onSubmitEnquiryCustomer,
      sendEnquiryErrorListing,
      onJobDoneReleaseFunds,
      jobDoneReleaseFundsInProgress,
      jobDoneReleaseFundsError,
      history,
      applicationTransaction,
      applicationPortfolioWorks,
      skillOptions,
      toolOptions,
      stripeAccount,
      onRequestInvoicing,
      onLookupInvoicingCompany,
      onClearInvoicingRequest,
      requestInvoicingInProgress,
      requestInvoicingError,
      requestInvoicingResult,
      lookupInvoicingCompanyInProgress,
      lookupInvoicingCompanyError,
      lookupInvoicingCompanyResult,
    } = this.props;

    const currentTransaction = ensureTransaction(transaction);
    const projectBidDescription =
      currentTransaction?.attributes?.protectedData?.customOfferDescription;

    //For the process change. Old process versions are not supported anymore. This is a temporary fix.
    //Remove this when there is no transactions with old process versions.
    const isStaging =
      process.env.REACT_APP_FINNISH_ROOT_URL === 'https://freedomly-staging.freedomly.io';
    const defaultProcessVersion = isStaging ? 70 : 26;
    const lightProcessVersion = isStaging ? 31 : 14;
    const projectProcessVersion = isStaging ? 20 : 8;
    const oldDefaultProcess =
      currentTransaction.attributes.processName === 'flex-default-process' &&
      currentTransaction.attributes.processVersion < defaultProcessVersion;
    const oldLightProcess =
      currentTransaction.attributes.processName === 'flex-light-process' &&
      currentTransaction.attributes.processVersion < lightProcessVersion;
    const oldProjectProcess =
      currentTransaction.attributes.processName === 'flex-project-process' &&
      currentTransaction.attributes.processVersion <= projectProcessVersion;

    const processName = currentTransaction.attributes.processName;

    const currentListing = ensureListing(currentTransaction.listing);
    const currentProvider = ensureUser(currentTransaction.provider);

    const currentCustomer = ensureUser(currentTransaction.customer);
    const isProOrInvoiceCustomer = isInvoiceBilledCustomer(currentCustomer);
    // What this transaction IS, from the transitions it has taken. Rendering
    // decisions use these two; the customer flag only decides whether to
    // offer invoice payment on a pending offer.
    const usesInvoicePath = txUsesInvoicePath(currentTransaction);
    const isLegacyPro = txIsLegacyProProcess(currentTransaction);
    const isCustomer = transactionRole === 'customer';
    const isProvider = transactionRole === 'provider';

    // Check if provider is a light entrepreneur
    const providerRole = currentProvider?.attributes?.profile?.publicData?.account_role;
    const isProviderLightEntrepreneur = providerRole === 'light-entrepreneur';

    // Gate: providers must have completed tax information AND (unless they
    // are a light entrepreneur, who doesn't use Stripe) a fully onboarded
    // Stripe Connect account before they can interact with a conversation.
    //
    // fetchCurrentUser (dispatched in TransactionPage.loadData) includes the
    // stripeAccount relationship and populates state.stripeConnectAccount
    // when it exists. Absence of stripeAccount + id means the user has not
    // started Stripe onboarding; presence with incomplete data means they
    // started but have outstanding requirements.
    const currentUserAccountRole = currentUser?.attributes?.profile?.publicData?.account_role;
    const isCurrentUserLightEntrepreneur = currentUserAccountRole === 'light-entrepreneur';
    const providerTax = currentUser?.attributes?.profile?.privateData?.tax;
    const taxInformationCollected = !!currentUser?.attributes?.profile?.privateData
      ?.taxInformationCollected;
    const stripeRequiredForCurrentUser = isProvider && !isCurrentUserLightEntrepreneur;
    const missingTax = isProvider && !!currentUser && !taxInformationCollected;
    // The tax form may be filled in but predate the VAT declaration (spec §5).
    const missingVatStatus =
      isProvider && !!currentUser && !missingTax && !vatDeclared(providerTax);
    const missingStripe = stripeRequiredForCurrentUser && !isStripeAccountComplete(stripeAccount);
    const showProviderOnboardingModal =
      isProvider && !!currentUser && (missingTax || missingVatStatus || missingStripe);
    const vatReminder =
      isProvider && !showProviderOnboardingModal ? vatStatusReminder(providerTax) : null;

    const isCustomOfferMade =
      currentTransaction.attributes.protectedData &&
      currentTransaction.attributes.protectedData?.customOfferAmount;

    // Which invoice option the pending-offer modal shows the customer. Legacy
    // pro transactions accept through their own transition and show no choice.
    const invoiceOption =
      isCustomer && isCustomOfferMade && !isLegacyPro
        ? invoiceOptionState(currentUser, nextTransitions)
        : null;

    const currentOfferAmount =
      currentTransaction.attributes.protectedData?.customOfferAmount !== undefined
        ? new Money(currentTransaction.attributes.protectedData?.customOfferAmount, 'EUR')
        : new Money(0, 'EUR');

    const panelProtectedData = currentTransaction.attributes.protectedData || {};
    const panelResolution = resolutionForOffer(currentTransaction, this.props.vatPreview);
    // The display rule: a pending offer previews, an accepted transaction
    // prints its line items (customer service fee spec §1).
    const panelTotals = offerTotals({
      lineItems: currentTransaction.attributes.lineItems,
      isPending: PENDING_OFFER_TRANSITIONS.includes(currentTransaction.attributes.lastTransition),
      resolution: panelResolution,
      customerPrice: panelProtectedData.customOfferAmount || 0,
    });
    // The customer's VAT line covers the work and the fee.
    const customOfferVATAmount = new Money(panelTotals.customerVat + panelTotals.feeVat, 'EUR');
    const customOfferPlusVATAmount = new Money(panelTotals.customerTotal, 'EUR');

    const customOfferDescription =
      currentTransaction.attributes.protectedData?.customOfferDescription || '';

    const customOfferDeliveryDate =
      currentTransaction.attributes.protectedData?.customOfferDeliveryDate;

    // Offers made before the start date existed have none; the accept form and
    // the edit form both fall back to the delivery date alone.
    const customOfferStartDate = currentTransaction.attributes.protectedData?.customOfferStartDate;

    const listingLoaded = !!currentListing.id;
    const listingDeleted = listingLoaded && currentListing.attributes.deleted;
    const iscustomerLoaded = !!currentCustomer.id;
    const isCustomerBanned = iscustomerLoaded && currentCustomer.attributes.banned;
    const isCustomerDeleted = iscustomerLoaded && currentCustomer.attributes.deleted;
    const isProviderLoaded = !!currentProvider.id;
    const isProviderBanned = isProviderLoaded && currentProvider.attributes.banned;
    const isProviderDeleted = isProviderLoaded && currentProvider.attributes.deleted;

    const { publicData = {} } = currentListing.attributes;
    const { listingType = '' } = publicData;

    const isFreelancer =
      currentUser &&
      ['freelancer', 'light-entrepreneur'].includes(
        currentUser.attributes.profile.publicData.account_role
      );

    const stateDataFn = tx => {
      if (txIsEnquired(tx)) {
        const transitions = Array.isArray(nextTransitions)
          ? nextTransitions.map(transition => {
              return transition.attributes.name;
            })
          : [];
        const hasCorrectNextTransition =
          transitions.length > 0 &&
          (transitions.includes(TRANSITION_REQUEST_PAYMENT_AFTER_ENQUIRY) ||
            transitions.includes(TRANSITION_ACCEPT_CUSTOM_OFFER_INVOICE) ||
            transitions.includes('transition/accept-custom-pro-offer'));
        return {
          headingState: HEADING_ENQUIRED,
          showBookingPanel: !isProviderBanned && hasCorrectNextTransition,
          showProjectBookingPanel: !isProviderBanned && listingType === 'project',
        };
      } else if (txIsPaymentPending(tx)) {
        return {
          headingState: HEADING_PAYMENT_PENDING,
          showDetailCardHeadings: isCustomer,
        };
      } else if ([TRANSITION_MAKE_CUSTOM_PRO_OFFER].includes(txLastTransition(tx))) {
        return {
          headingState: HEADING_PAYMENT_PENDING,
          showDetailCardHeadings: isCustomer,
        };
      } else if (txIsPaymentExpired(tx)) {
        return {
          headingState: HEADING_PAYMENT_EXPIRED,
          showDetailCardHeadings: isCustomer,
        };
      } else if (txIsRequested(tx)) {
        return {
          headingState: HEADING_REQUESTED,
          showDetailCardHeadings: isCustomer,
          showSaleButtons: isProvider && !isCustomerBanned,
        };
      } else if (
        [
          TRANSITION_CONFIRM_PAYMENT,
          TRANSITION_ACCEPT_CUSTOM_PRO_OFFER,
          TRANSITION_ACCEPT_CUSTOM_OFFER_INVOICE,
        ].includes(txLastTransition(tx))
      ) {
        return {
          headingState: HEADING_ACCEPTED,
          showJobReadyButton: isProvider && !isCustomerBanned,
          showDetailCardHeadings: isCustomer,
          showAddress: isCustomer,
          showJobDoneReleaseFundsButton:
            isCustomer && !oldDefaultProcess && !oldLightProcess && !usesInvoicePath,
          // Invoice twin of the release-funds shortcut; the legacy pro process has none.
          showJobDoneAcceptInvoiceButton: isCustomer && usesInvoicePath && !isLegacyPro,
          showJobDoneCustomerButton: isCustomer && (oldDefaultProcess || oldLightProcess),
        };
      } else if (txIsDeclined(tx)) {
        return {
          headingState: HEADING_DECLINED,
          showDetailCardHeadings: isCustomer,
        };
      } else if (txIsCanceled(tx)) {
        return {
          headingState: HEADING_CANCELED,
          showDetailCardHeadings: isCustomer,
        };
      } else if (txHasBeenDelivered(tx)) {
        return {
          headingState: HEADING_DELIVERED,
          showDetailCardHeadings: isCustomer,
          showAddress: isCustomer,
        };
      } else if (
        [TRANSITION_MAKE_PROJECT_BID, TRANSITION_MAKE_PROJECT_BID_AFTER_ENQUIRY].includes(
          txLastTransition(tx)
        )
      ) {
        return {
          headingState: HEADING_OFFER_MADE,
          showDetailCardHeadings: isCustomer,
          showAddress: isCustomer,
          showProjectSaleButtons: isProvider && !isCustomerBanned,
        };
      } else if ([TRANSITION_ACCEPT_OFFER].includes(txLastTransition(tx))) {
        return {
          headingState: HEADING_OFFER_ACCEPTED,
          showDetailCardHeadings: isCustomer,
          showAddress: isCustomer,
        };
      } else if (
        [TRANSITION_DECLINE_OFFER, TRANSITION_EXPIRE_OFFER].includes(txLastTransition(tx))
      ) {
        return {
          headingState: HEADING_OFFER_DECLINED,
          showDetailCardHeadings: isCustomer,
          showAddress: isCustomer,
        };
      } else if (
        [TRANSITION_JOB_DONE, TRANSITION_JOB_DONE_PRO, TRANSITION_JOB_DONE_INVOICE].includes(
          txLastTransition(tx)
        )
      ) {
        return {
          headingState: HEADING_JOB_DONE,
          showReleaseFundsButton: isCustomer && !usesInvoicePath,
          showAcceptProButton: isCustomer && usesInvoicePath,
          showCustomOfferFormAccepted: usesInvoicePath,
        };
      } else if ([TRANSITION_JOB_DONE_CUSTOMER].includes(txLastTransition(tx))) {
        return {
          headingState: HEADING_JOB_DONE_CUSTOMER,
          showReleaseFundsButton: isCustomer && !usesInvoicePath,
        };
      } else if (
        [
          TRANSITION_JOB_ACCEPTED,
          TRANSITION_ACCEPT_JOB_INVOICE,
          TRANSITION_JOB_DONE_ACCEPT_INVOICE,
        ].includes(txLastTransition(tx))
      ) {
        return {
          headingState: HEADING_JOB_ACCEPTED,
          showReleaseFundsButton: isCustomer && !usesInvoicePath,
          showCustomOfferFormAccepted: usesInvoicePath,
          showCustomOfferFormAcceptedProvider: usesInvoicePath,
        };
      } else if (
        [
          TRANSITION_REVIEW_1_BY_PROVIDER,
          TRANSITION_REVIEW_1_BY_CUSTOMER,
          TRANSITION_REVIEW_2_BY_PROVIDER,
          TRANSITION_REVIEW_2_BY_CUSTOMER,
        ].includes(txLastTransition(tx))
      ) {
        return {
          headingState: HEADING_JOB_ACCEPTED,
          showCustomOfferFormAccepted: usesInvoicePath,
          showCustomOfferFormAcceptedProvider: usesInvoicePath,
        };
      } else {
        return { headingState: 'unknown' };
      }
    };
    const stateData = stateDataFn(currentTransaction);

    // Use centralized action needed logic consistent with ProcessStepsCard and ActivityFeed
    const lastTransition = currentTransaction?.attributes?.lastTransition;
    const userRole = transactionRole; // 'customer' or 'provider'

    // Check if user needs to leave a review (using isCustomer defined earlier)
    const reviewStartTransitions = [
      TRANSITION_RELEASE_FUNDS,
      TRANSITION_JOB_DONE_RELEASE_FUNDS,
      TRANSITION_JOB_ACCEPTED,
      TRANSITION_ACCEPT_JOB_INVOICE,
      TRANSITION_JOB_DONE_ACCEPT_INVOICE,
    ];
    const isInReviewPhase =
      reviewStartTransitions.includes(lastTransition) ||
      txIsInFirstReviewBy(currentTransaction, isCustomer) ||
      txIsInFirstReviewBy(currentTransaction, !isCustomer);
    const userHasNotLeftReview =
      isInReviewPhase && !txIsInFirstReviewBy(currentTransaction, isCustomer);

    const showTimelineNotification =
      userHasNotLeftReview ||
      isActionNeeded(lastTransition, lastTransition, userRole) ||
      (isProvider && txIsEnquired(currentTransaction) && !isCustomOfferMade);

    const deletedListingTitle = intl.formatMessage({
      id: 'TransactionPanel.deletedListingTitle',
    });

    const {
      authorDisplayName,
      customerDisplayName,
      otherUserDisplayName,
      otherUserDisplayNameString,
    } = displayNames(currentUser, currentProvider, currentCustomer, intl);

    const listingTitle = currentListing.attributes.deleted
      ? deletedListingTitle
      : currentTransaction.attributes.protectedData.listingTitle
      ? currentTransaction.attributes.protectedData?.listingTitle
      : '';

    const listingDescription = currentListing.attributes.deleted
      ? deletedListingTitle
      : currentListing.attributes.publicData.descriptionText;
    const authorStripeConnected = currentProvider.attributes.profile.publicData?.stripeConnected;

    const unitType = config.bookingUnitType;
    const isNightly = unitType === LINE_ITEM_NIGHT;
    const isDaily = unitType === LINE_ITEM_DAY;

    const unitTranslationKey = isNightly
      ? 'TransactionPanel.perNight'
      : isDaily
      ? 'TransactionPanel.perDay'
      : 'TransactionPanel.perUnit';

    const price = currentListing.attributes.price;
    const bookingSubTitle = price
      ? `${formatMoney(intl, price)} ${intl.formatMessage({ id: unitTranslationKey })}`
      : '';

    const firstImage =
      currentListing.images && currentListing.images.length > 0 ? currentListing.images[0] : null;

    const slug = createSlug(listingTitle);

    const isTransactionFromApplication =
      currentTransaction.attributes?.protectedData?.applicationId !== undefined;

    const customOfferPlaceholder = intl.formatMessage({
      id: 'TransactionPanel.customOfferPlaceholder',
    });

    const customOfferFormAccepted = usesInvoicePath ? (
      <CustomOfferAcceptedForm
        formId="customOfferForm"
        rootClassName={css.customOfferForm}
        messagePlaceholder={customOfferPlaceholder}
        isProvider={isProvider}
        customOfferAmount={currentOfferAmount}
        customOfferPlusVATAmount={customOfferPlusVATAmount}
        customOfferVATAmount={customOfferVATAmount}
        customOfferTitle={currentTransaction.attributes.protectedData?.customOfferTitle}
        customOfferDescription={customOfferDescription}
        customOfferStartDate={customOfferStartDate}
        customOfferDeliveryDate={customOfferDeliveryDate}
        inProgress={false}
        offerError={null}
        onSubmit={() => this.handleAcceptCustomOffer('card')}
        isProOrInvoiceCustomer={usesInvoicePath}
        showCustomOfferFormAcceptedProvider={stateData.showCustomOfferFormAcceptedProvider}
        vatResolution={panelResolution}
        totals={panelTotals}
      />
    ) : null;

    // Contains all action buttons expect ones related to custom offer.
    const saleButtons = (
      <SaleActionButtonsMaybe
        currentTransaction={currentTransaction}
        acceptInProgress={acceptInProgress}
        declineInProgress={declineInProgress}
        releaseFundsInProgress={releaseFundsInProgress}
        acceptSaleError={acceptSaleError}
        declineSaleError={declineSaleError}
        releaseFundsError={releaseFundsError}
        jobDoneReleaseFundsInProgress={jobDoneReleaseFundsInProgress}
        jobDoneReleaseFundsError={jobDoneReleaseFundsError}
        onManageDisableScrolling={onManageDisableScrolling}
        stateData={stateData}
        intl={intl}
        onAcceptSale={() => onAcceptSale(currentTransaction.id)}
        onDeclineSale={() => onDeclineSale(currentTransaction.id)}
        onReleaseFunds={() => onReleaseFunds(currentTransaction.id)}
        onJobDoneReleaseFunds={() => onJobDoneReleaseFunds(currentTransaction.id)}
        onJobReady={() => onJobReady(currentTransaction.id)}
        onJobReadyCustomer={() => onJobReadyCustomer(currentTransaction.id)}
        onJobReadyPro={() =>
          isLegacyPro
            ? onJobReadyPro(currentTransaction.id)
            : onJobDoneInvoice(currentTransaction.id)
        }
        isProOrInvoiceCustomer={usesInvoicePath}
        onAcceptProJob={() => {
          this.handleAcceptProJobWithConfirm(() => {
            if (isLegacyPro) onAcceptProJob(currentTransaction.id);
            else onAcceptJobInvoice(currentTransaction.id);
          });
        }}
        onJobDoneAcceptInvoice={() => {
          this.handleAcceptProJobWithConfirm(() => {
            onJobDoneAcceptInvoice(currentTransaction.id);
          });
        }}
        customOfferFormAccepted={customOfferFormAccepted}
      />
    );

    const projectActionButtons = (
      <ProjectActionButtonsMaybe
        showButtons={stateData.showProjectSaleButtons}
        acceptInProgress={showProfileListingInProgress}
        declineInProgress={declineProjectBidInProgress}
        acceptSaleError={showProfileListingError}
        declineSaleError={declineProjectBidError}
        onAcceptSale={onSubmitAcceptBidRequest}
        onDeclineSale={() => onDeclineProjectBid(currentTransaction.id)}
      />
    );

    const showSendMessageForm =
      !isCustomerBanned && !isCustomerDeleted && !isProviderBanned && !isProviderDeleted;

    const sendMessagePlaceholder = intl.formatMessage(
      { id: 'TransactionPanel.sendMessagePlaceholder' },
      { name: otherUserDisplayNameString }
    );

    const sendingMessageNotAllowed = intl.formatMessage({
      id: 'TransactionPanel.sendingMessageNotAllowed',
    });

    const paymentMethodsPageLink = (
      <NamedLink name="BillingPage">
        <FormattedMessage id="TransactionPanel.paymentMethodsPageLink" />
      </NamedLink>
    );

    const currentListingType = currentListing.attributes.publicData?.listingType;
    const isListingClosed = currentListing.attributes.state === 'closed';
    const projectBidButtonText = <FormattedMessage id="TransactionPanel.ctaButtonProjectBid" />;

    const backToApplicationLinkText = intl.formatMessage({
      id: 'TransactionPanel.backToApplicationLink',
    });

    const handleCustomOfferModal = () => this.openCustomOfferModal(isCustomOfferMade);

    const openCustomOfferModalButton = [
      HEADING_DECLINED,
      HEADING_ENQUIRED,
      HEADING_REQUESTED,
      HEADING_OFFER_MADE,
      HEADING_CANCELED,
      HEADING_OFFER_DECLINED,
    ].includes(stateData.headingState) ? (
      <SecondaryButton
        className={css.openCustomOfferModalButton}
        onClick={() => handleCustomOfferModal()}
      >
        <FormattedMessage
          id={isCustomOfferMade ? 'CustomOfferForm.updateAnOffer' : 'CustomOfferForm.makeAnOffer'}
        />
      </SecondaryButton>
    ) : null;

    const handleAcceptCustomOfferModalOpen = () => {
      this.setState({ acceptCustomOfferModalOpen: true });
    };

    const acceptCustomOfferProModal = isCustomOfferMade ? (
      <CustomOfferModal
        isOpen={this.state.acceptCustomOfferModalOpen}
        onClose={() => {
          this.setState({ acceptCustomOfferModalOpen: false });
        }}
        onManageDisableScrolling={onManageDisableScrolling}
        customOfferData={customOfferDataFromTransaction(currentTransaction, isCustomer)}
        isCustomer={isCustomer}
        intl={intl}
        onAcceptCustomOffer={paymentMethod => this.handleAcceptCustomOffer(paymentMethod)}
        acceptOfferInProgress={acceptInProgress || acceptOfferInvoiceInProgress}
        acceptOfferError={acceptOfferInvoiceError || acceptCustomProOfferError}
        transactionLastTransition={currentTransaction.attributes.lastTransition}
        onDownloadAttachment={onDownloadAttachment}
        onOpenAttachment={onOpenAttachment}
        onFetchAttachmentPreview={onFetchAttachmentPreview}
        attachmentPreviewUrls={attachmentPreviewUrls}
        downloadAttachmentInProgressIds={downloadAttachmentInProgressIds}
        onUpdateOffer={() => {
          this.setState({ acceptCustomOfferModalOpen: false });
          this.openCustomOfferModal(true);
        }}
        invoiceOption={invoiceOption}
        paymentTermDays={INVOICE_PAYMENT_TERM_DAYS}
        onRequestInvoicing={() => {
          this.setState({ acceptCustomOfferModalOpen: false, requestInvoicingModalOpen: true });
        }}
        vatPreview={this.props.vatPreview}
        vatPreviewInProgress={this.props.vatPreviewInProgress}
        vatPreviewError={this.props.vatPreviewError}
        onRetryVatPreview={this.fetchVatPreview}
        onPaymentMethodChange={this.fetchVatPreview}
        onSaveBillingDetails={this.props.onSaveBillingDetails}
        saveBillingDetailsInProgress={this.props.saveBillingDetailsInProgress}
        saveBillingDetailsError={this.props.saveBillingDetailsError}
        billingInitialValues={billingInitialValuesForUser(currentUser)}
        lockedBillingFields={billingLockedFields(currentUser)}
      />
    ) : null;

    const requestInvoicingModal = (
      <RequestInvoicingModal
        isOpen={this.state.requestInvoicingModalOpen}
        onClose={() => {
          onClearInvoicingRequest();
          this.setState({ requestInvoicingModalOpen: false, acceptCustomOfferModalOpen: true });
        }}
        onManageDisableScrolling={onManageDisableScrolling}
        intl={intl}
        currentUser={currentUser}
        onLookupCompany={onLookupInvoicingCompany}
        lookupInProgress={lookupInvoicingCompanyInProgress}
        lookupResult={lookupInvoicingCompanyResult}
        lookupError={lookupInvoicingCompanyError}
        onSubmit={payload => onRequestInvoicing(payload, currentTransaction.id)}
        submitInProgress={requestInvoicingInProgress}
        submitError={requestInvoicingError}
        result={requestInvoicingResult}
        onSaveBillingDetails={this.props.onSaveBillingDetails}
        saveBillingDetailsInProgress={this.props.saveBillingDetailsInProgress}
        saveBillingDetailsError={this.props.saveBillingDetailsError}
      />
    );

    const classes = classNames(rootClassName || css.root, className);

    // Old transactions created from project doesn't have listing id in protected data,
    // so render plain title instead.
    const projectListingLink = currentTransaction.attributes.protectedData.listingId ? (
      <div className={css.projectLinks}>
        <NamedLink
          name="ProjectListingPage"
          params={{ id: currentTransaction.attributes.protectedData.listingId, slug }}
        >
          {listingTitle}
        </NamedLink>
        <NamedLink
          className={css.applicationLink}
          name={isCustomer ? 'ApplicationSalePage' : 'ApplicationOrderPage'}
          params={{ id: currentTransaction.attributes.protectedData.applicationId }}
        >
          {backToApplicationLinkText} &rarr;
        </NamedLink>
      </div>
    ) : (
      <div>{listingTitle}</div>
    );

    const listingLink = (
      <NamedLink name="ListingPage" params={{ id: currentListing.id.uuid, slug }}>
        {listingTitle}
      </NamedLink>
    );

    const bookingPanelListingLink = isTransactionFromApplication
      ? { ...projectListingLink }
      : { ...listingLink };

    // Redirect project process to application page if not legacy project
    if (processName === 'flex-project-process' && !oldProjectProcess) {
      return isCustomer ? (
        <NamedRedirect name="ApplicationOrderPage" params={{ id: currentTransaction.id.uuid }} />
      ) : (
        <NamedRedirect name="ApplicationSalePage" params={{ id: currentTransaction.id.uuid }} />
      );
    }

    const handleTabSwitch = txInfoOpen => {
      this.setState({ txInfoOpen });
    };

    return (
      <div className={classes}>
        <div className={css.backToInboxLink}>
          <NamedLink name="InboxPage" params={{ tab: isFreelancer ? 'sales' : 'orders' }}>
            <FormattedMessage id="TransactionPanel.backToInboxLink" />
          </NamedLink>
        </div>
        <div className={css.container}>
          {vatReminder && !this.state.vatBannerClosed ? (
            <VatStatusBanner
              reason={vatReminder}
              onClose={() => this.setState({ vatBannerClosed: true })}
            />
          ) : null}

          {/* {transactionRole === 'provider' &&
            txIsEnquired(currentTransaction) &&
            currentUser?.attributes?.profile?.publicData?.hideFreelancerOnboardingTip !== true &&
            !this.state.freelancerOnboardingBannerClosed && (
              <FreelancerOnboardingBanner
                onOpenModal={this.handleOpenFreelancerOnboarding}
                onClose={this.handleCloseBanner}
              />
            )} */}

          <div className={css.mobileTabs}>
            <div
              className={this.state.txInfoOpen ? css.mobileTabActive : css.mobileTab}
              onClick={() => handleTabSwitch(true)}
            >
              <FormattedMessage id="TransactionPanel.mobileTabTxInfo" />
            </div>
            <div
              className={this.state.txInfoOpen ? css.mobileTab : css.mobileTabActive}
              onClick={() => handleTabSwitch(false)}
            >
              <FormattedMessage id="TransactionPanel.mobileTabAsideDesktop" />
              {showTimelineNotification ? <BsBellFill className={css.notificationBell} /> : null}
            </div>
          </div>
          <div className={this.state.txInfoOpen ? css.txInfo : css.txInfoHiddenMobile}>
            <PanelHeading
              panelHeadingState={stateData.headingState}
              transactionRole={transactionRole}
              providerName={authorDisplayName}
              provider={currentProvider}
              customerName={customerDisplayName}
              isCustomerBanned={isCustomerBanned}
              listingId={currentListing.id && currentListing.id.uuid}
              listingTitle={listingTitle}
              listingDeleted={listingDeleted}
              listingType={listingType}
              projectTransaction={projectTransaction}
              currentCustomer={currentCustomer}
              currentProvider={currentProvider}
              openCustomOfferModalButton={openCustomOfferModalButton}
              applicationBannerButton={
                currentTransaction?.attributes?.protectedData?.applicationId &&
                !txIsProAccepted(currentTransaction) &&
                !txIsAccepted(currentTransaction) ? (
                  <ApplicationBanner onOpenApplicationModal={this.onOpenApplicationModal} />
                ) : null
              }
            />

            {savePaymentMethodFailed ? (
              <p className={css.genericError}>
                <FormattedMessage
                  id="TransactionPanel.savePaymentMethodFailed"
                  values={{ paymentMethodsPageLink }}
                />
              </p>
            ) : null}
            <div className={css.conversationAndMessageFormWrapper}>
              <div className={css.conversationWrapper}>
                <div className={css.conversationContent}>
                  <FeedSection
                    rootClassName={css.feedContainer}
                    currentTransaction={currentTransaction}
                    vatPreview={this.props.vatPreview}
                    currentUser={currentUser}
                    ownReview={this.props.ownReview}
                    fetchMessagesError={fetchMessagesError}
                    fetchMessagesInProgress={fetchMessagesInProgress}
                    initialMessageFailed={initialMessageFailed}
                    messages={messages}
                    oldestMessagePageFetched={oldestMessagePageFetched}
                    onOpenReviewModal={this.onOpenReviewModal}
                    onOpenOfferModal={() => this.setState({ acceptCustomOfferModalOpen: true })}
                    onOpenInvoiceModal={() => this.setState({ invoiceInfoModalOpen: true })}
                    onShowMoreMessages={() => onShowMoreMessages(currentTransaction.id)}
                    totalMessagePages={totalMessagePages}
                    intl={intl}
                    stepActions={{
                      onJobReady: () => {
                        this.handleWorkCompleteWithConfirm(() => {
                          if (
                            processName === 'flex-default-process' ||
                            processName === 'flex-light-process'
                          ) {
                            onJobReady(currentTransaction.id, intl);
                          }
                        });
                      },
                      onJobReadyPro: () => {
                        this.handleWorkCompleteWithConfirm(() => {
                          onJobReadyPro(currentTransaction.id, intl);
                        });
                      },
                      onReleaseFunds: () => {
                        this.handleReleaseFundsWithConfirm(() => {
                          onReleaseFunds(currentTransaction.id);
                        });
                      },
                      onJobDoneReleaseFunds: () => {
                        this.handleReleaseFundsWithConfirm(() => {
                          onJobDoneReleaseFunds(currentTransaction.id);
                        });
                      },
                      onAcceptProJob: () => {
                        this.handleAcceptProJobWithConfirm(() => {
                          onAcceptProJob(currentTransaction.id, intl);
                        });
                      },
                      onJobDoneInvoicePath: () => {
                        this.handleWorkCompleteWithConfirm(() => {
                          if (isLegacyPro) onJobReadyPro(currentTransaction.id, intl);
                          else onJobDoneInvoice(currentTransaction.id);
                        });
                      },
                      onAcceptJobInvoicePath: () => {
                        this.handleAcceptProJobWithConfirm(() => {
                          if (isLegacyPro) onAcceptProJob(currentTransaction.id, intl);
                          else onAcceptJobInvoice(currentTransaction.id);
                        });
                      },
                      ...(isLegacyPro
                        ? {}
                        : {
                            onJobDoneAcceptInvoice: () => {
                              this.handleAcceptProJobWithConfirm(() => {
                                onJobDoneAcceptInvoice(currentTransaction.id);
                              });
                            },
                          }),
                      onOpenReviewModal: () => {
                        this.onOpenReviewModal();
                      },
                      onAcceptCustomOffer: () => {
                        handleAcceptCustomOfferModalOpen();
                      },
                    }}
                    actionInProgress={
                      acceptInProgress ||
                      declineInProgress ||
                      releaseFundsInProgress ||
                      jobDoneReleaseFundsInProgress
                    }
                    onManageDisableScrolling={onManageDisableScrolling}
                    onDownloadAttachment={onDownloadAttachment}
                    onOpenAttachment={onOpenAttachment}
                    onFetchAttachmentPreview={onFetchAttachmentPreview}
                    attachmentPreviewUrls={attachmentPreviewUrls}
                    downloadAttachmentInProgressIds={downloadAttachmentInProgressIds}
                    downloadAttachmentError={downloadAttachmentError}
                  />
                </div>
              </div>

              {showSendMessageForm ? (
                <SendMessageForm
                  formId={this.sendMessageFormName}
                  rootClassName={css.sendMessageForm}
                  currentUser={currentUser}
                  messagePlaceholder={sendMessagePlaceholder}
                  inProgress={sendMessageInProgress}
                  sendMessageError={sendMessageError}
                  onFocus={this.onSendMessageFormFocus}
                  onBlur={this.onSendMessageFormBlur}
                  onSubmit={this.onMessageSubmit}
                  stagedAttachments={stagedAttachments}
                  onUploadAttachment={onUploadAttachment}
                  onRemoveAttachment={onRemoveAttachment}
                  openCustomOfferModalButton={openCustomOfferModalButton}
                />
              ) : (
                <div className={css.sendingMessageNotAllowed}>{sendingMessageNotAllowed}</div>
              )}
            </div>

            {stateData.showProjectSaleButtons ? (
              <div className={css.mobileActionButtons}>{projectActionButtons}</div>
            ) : null}
          </div>

          <div className={!this.state.txInfoOpen ? css.asideDesktop : css.asideDesktopHiddenMobile}>
            <ProcessStepsCard
              transaction={currentTransaction}
              vatPreview={this.props.vatPreview}
              transactionRole={transactionRole}
              currentUser={currentUser}
              intl={intl}
              stepActions={{
                onJobReady: () => {
                  this.handleWorkCompleteWithConfirm(() => {
                    if (
                      processName === 'flex-default-process' ||
                      processName === 'flex-light-process'
                    ) {
                      onJobReady(currentTransaction.id, intl);
                    }
                  });
                },
                onJobReadyPro: () => {
                  this.handleWorkCompleteWithConfirm(() => {
                    onJobReadyPro(currentTransaction.id, intl);
                  });
                },
                onReleaseFunds: () => {
                  this.handleReleaseFundsWithConfirm(() => {
                    onReleaseFunds(currentTransaction.id);
                  });
                },
                onJobDoneReleaseFunds: () => {
                  this.handleReleaseFundsWithConfirm(() => {
                    onJobDoneReleaseFunds(currentTransaction.id);
                  });
                },
                onAcceptProJob: () => {
                  this.handleAcceptProJobWithConfirm(() => {
                    onAcceptProJob(currentTransaction.id, intl);
                  });
                },
                onJobDoneInvoicePath: () => {
                  this.handleWorkCompleteWithConfirm(() => {
                    if (isLegacyPro) onJobReadyPro(currentTransaction.id, intl);
                    else onJobDoneInvoice(currentTransaction.id);
                  });
                },
                onAcceptJobInvoicePath: () => {
                  this.handleAcceptProJobWithConfirm(() => {
                    if (isLegacyPro) onAcceptProJob(currentTransaction.id, intl);
                    else onAcceptJobInvoice(currentTransaction.id);
                  });
                },
                ...(isLegacyPro
                  ? {}
                  : {
                      onJobDoneAcceptInvoice: () => {
                        this.handleAcceptProJobWithConfirm(() => {
                          onJobDoneAcceptInvoice(currentTransaction.id);
                        });
                      },
                    }),
                onOpenReviewModal: () => {
                  this.onOpenReviewModal();
                },
                onAcceptCustomOffer: () => {
                  handleAcceptCustomOfferModalOpen();
                },
              }}
              actionInProgress={
                acceptInProgress ||
                declineInProgress ||
                releaseFundsInProgress ||
                jobDoneReleaseFundsInProgress
              }
              isProOrInvoiceCustomer={isProOrInvoiceCustomer}
              onManageDisableScrolling={onManageDisableScrolling}
              listing={currentListing}
              provider={currentProvider}
              listingTitle={listingTitle}
              isListingClosed={isListingClosed}
              onSubmitEnquiryCustomer={onSubmitEnquiryCustomer}
              sendEnquiryInProgress={sendEnquiryInProgress}
              sendEnquiryErrorListing={sendEnquiryErrorListing}
              openCustomOfferModalButton={openCustomOfferModalButton}
              onOpenOfferModal={() => this.setState({ acceptCustomOfferModalOpen: true })}
              onDownloadReceipt={onDownloadReceipt}
              downloadReceiptInProgressId={downloadReceiptInProgressId}
              downloadReceiptFailedId={downloadReceiptFailedId}
            />
          </div>
        </div>
        <ReviewModal
          id="ReviewOrderModal"
          isOpen={this.state.isReviewModalOpen}
          onCloseModal={() => this.setState({ isReviewModalOpen: false })}
          onManageDisableScrolling={onManageDisableScrolling}
          onSubmitReview={this.onSubmitReview}
          revieweeName={otherUserDisplayName}
          reviewSent={this.state.reviewSubmitted}
          sendReviewInProgress={sendReviewInProgress}
          sendReviewError={sendReviewError}
          transactionRole={transactionRole}
        />
        <Modal
          id="ProjectListingPage.projectBid"
          contentClassName={css.enquiryModalContent}
          isOpen={this.state.projectBidModalOpen}
          onClose={() => this.setState({ projectBidModalOpen: false })}
          onManageDisableScrolling={onManageDisableScrolling}
        >
          <ProjectBidForm
            className={css.enquiryForm}
            listingTitle={listingTitle}
            authorDisplayName={authorDisplayName}
            provider={currentProvider}
            sendEnquiryError={sendProjectBidError}
            onSubmit={this.onSubmitProjectBid}
            inProgress={sendProjectBidInProgress}
          />
        </Modal>
        <Modal
          id="TransactionPage.customOffer"
          isOpen={this.state.customOfferModalOpen}
          onClose={this.closeCustomOfferModal}
          onManageDisableScrolling={onManageDisableScrolling}
        >
          <CustomOfferStripeGate
            status={this.state.offerStripeStatus}
            onGetStripeConnectAccountLink={this.handleOfferStripeAccountLink}
            linkInProgress={this.props.getAccountLinkInProgress}
          >
            <CustomOfferForm
              key={this.customOfferDraftKey()}
              formId="customOfferForm"
              isOpen={this.state.customOfferModalOpen}
              rootClassName={css.enquiryForm}
              customOfferPlaceholder={customOfferPlaceholder}
              isProvider={isProvider}
              isLightEntrepreneur={isProviderLightEntrepreneur}
              inProgress={sendCustomOfferInProgress}
              offerError={sendCustomOfferError}
              onSubmit={this.handleSendCustomOffer}
              isProOrInvoiceCustomer={isProOrInvoiceCustomer}
              attachmentsEnabled={offerAttachmentsSupported(nextTransitions)}
              stagedAttachments={offerStagedAttachments}
              onUploadAttachment={onUploadOfferAttachment}
              onRemoveAttachment={onRemoveOfferAttachment}
              vatResolution={panelResolution}
              initialValues={
                this.state.isUpdatingCustomOffer && isCustomOfferMade
                  ? {
                      title: currentTransaction.attributes.protectedData?.customOfferTitle,
                      description: customOfferDescription,
                      customOfferAmount: new Money(
                        currentTransaction.attributes.protectedData?.customOfferAmount,
                        'EUR'
                      ),
                      startDate: customOfferStartDate
                        ? { date: new Date(customOfferStartDate) }
                        : null,
                      deliveryDate: customOfferDeliveryDate
                        ? { date: new Date(customOfferDeliveryDate) }
                        : null,
                    }
                  : undefined
              }
            />
          </CustomOfferStripeGate>
        </Modal>
        <ProviderOnboardingRequiredModal
          id="TransactionPanel.providerOnboardingRequired"
          isOpen={showProviderOnboardingModal}
          onManageDisableScrolling={onManageDisableScrolling}
          missingTax={missingTax}
          missingStripe={missingStripe}
          missingVatStatus={missingVatStatus}
        />
        <Modal
          id="TransactionPanel.workComplete"
          contentClassName={css.workCompleteModalContent}
          isOpen={this.state.workCompleteModalOpen}
          onClose={this.cancelWorkComplete}
          onManageDisableScrolling={onManageDisableScrolling}
        >
          <div className={css.workCompleteModalContainer}>
            <h2 className={css.workCompleteModalTitle}>
              <FormattedMessage id="TransactionPanel.workCompleteConfirmTitle" />
            </h2>
            <p className={css.workCompleteModalText}>
              <FormattedMessage id="TransactionPanel.workCompleteConfirmText" />
            </p>
            <div className={css.workCompleteModalButtons}>
              <SecondaryButton onClick={this.cancelWorkComplete}>
                <FormattedMessage id="TransactionPanel.workCompleteCancel" />
              </SecondaryButton>
              <PrimaryButton
                onClick={this.confirmWorkComplete}
                inProgress={
                  acceptInProgress ||
                  declineInProgress ||
                  releaseFundsInProgress ||
                  jobDoneReleaseFundsInProgress
                }
                disabled={
                  acceptInProgress ||
                  declineInProgress ||
                  releaseFundsInProgress ||
                  jobDoneReleaseFundsInProgress
                }
              >
                <FormattedMessage id="TransactionPanel.workCompleteConfirm" />
              </PrimaryButton>
            </div>
          </div>
        </Modal>
        <Modal
          id="TransactionPanel.releaseFunds"
          contentClassName={css.releaseFundsModalContent}
          isOpen={this.state.releaseFundsModalOpen}
          onClose={this.cancelReleaseFunds}
          onManageDisableScrolling={onManageDisableScrolling}
        >
          <div className={css.releaseFundsModalContainer}>
            <h2 className={css.releaseFundsModalTitle}>
              <FormattedMessage id="TransactionPanel.releaseFundsModalHeader" />
            </h2>
            <p className={css.releaseFundsModalText}>
              <FormattedMessage id="TransactionPanel.releaseFundsModalMessage" />
            </p>
            <div className={css.releaseFundsModalButtons}>
              <SecondaryButton onClick={this.cancelReleaseFunds}>
                <FormattedMessage id="TransactionPanel.releaseFundsModalCancel" />
              </SecondaryButton>
              <PrimaryButton
                onClick={this.confirmReleaseFunds}
                inProgress={
                  acceptInProgress ||
                  declineInProgress ||
                  releaseFundsInProgress ||
                  jobDoneReleaseFundsInProgress
                }
                disabled={
                  acceptInProgress ||
                  declineInProgress ||
                  releaseFundsInProgress ||
                  jobDoneReleaseFundsInProgress
                }
              >
                <FormattedMessage id="TransactionPanel.releaseFundsButton" />
              </PrimaryButton>
            </div>
          </div>
        </Modal>
        <Modal
          id="TransactionPanel.acceptProJob"
          contentClassName={css.acceptProJobModalContent}
          isOpen={this.state.acceptProJobModalOpen}
          onClose={this.cancelAcceptProJob}
          onManageDisableScrolling={onManageDisableScrolling}
        >
          <div className={css.acceptProJobModalContainer}>
            <h2 className={css.acceptProJobModalTitle}>
              <FormattedMessage id="TransactionPanel.acceptProJobConfirmTitle" />
            </h2>
            <p className={css.acceptProJobModalText}>
              <FormattedMessage id="TransactionPanel.acceptProJobConfirmText" />
            </p>
            <div className={css.acceptProJobModalButtons}>
              <SecondaryButton onClick={this.cancelAcceptProJob}>
                <FormattedMessage id="TransactionPanel.acceptProJobCancel" />
              </SecondaryButton>
              <PrimaryButton
                onClick={this.confirmAcceptProJob}
                inProgress={acceptInProgress || declineInProgress}
                disabled={acceptInProgress || declineInProgress}
              >
                <FormattedMessage id="TransactionPanel.acceptProJobConfirm" />
              </PrimaryButton>
            </div>
          </div>
        </Modal>
        {acceptCustomOfferProModal}
        {requestInvoicingModal}
        <InvoiceInfoModal
          isOpen={this.state.invoiceInfoModalOpen}
          onClose={() => this.setState({ invoiceInfoModalOpen: false })}
          onManageDisableScrolling={onManageDisableScrolling}
          customOfferData={{
            amount: currentTransaction.attributes.protectedData?.customOfferAmount,
            payoutTotal: currentTransaction.attributes.payoutTotal,
            lineItems: currentTransaction.attributes.lineItems || [],
          }}
          intl={intl}
          customerName={currentTransaction.customer?.attributes?.profile?.displayName}
          transactionId={currentTransaction.id?.uuid}
          providerNet={panelTotals.providerNet}
        />
        {/* <FreelancerOnboardingModal
          isOpen={this.state.freelancerOnboardingModalOpen}
          onClose={this.handleCloseFreelancerOnboarding}
          onManageDisableScrolling={onManageDisableScrolling}
          onDismissPermanently={this.handleDismissFreelancerOnboarding}
        /> */}
        <ApplicationModal
          id="TransactionPanel.applicationModal"
          isOpen={this.state.applicationModalOpen}
          onClose={this.onCloseApplicationModal}
          onManageDisableScrolling={onManageDisableScrolling}
          applicationTransaction={applicationTransaction}
          intl={intl}
          skillOptions={skillOptions || []}
          toolOptions={toolOptions || []}
          portfolioWorks={applicationPortfolioWorks || []}
        />
        {typeof window === 'object' ? <ReactTooltip /> : null}
      </div>
    );
  }
}

TransactionPanelComponent.defaultProps = {
  getAccountLinkInProgress: false,
  onFetchStripeAccount: null,
  onGetStripeConnectAccountLink: null,
  rootClassName: null,
  className: null,
  currentUser: null,
  acceptSaleError: null,
  declineSaleError: null,
  fetchMessagesError: null,
  initialMessageFailed: false,
  savePaymentMethodFailed: false,
  sendMessageError: null,
  sendReviewError: null,
  timeSlots: null,
  fetchTimeSlotsError: null,
  nextTransitions: null,
  lineItems: null,
  fetchLineItemsError: null,
  acceptOfferInvoiceInProgress: false,
  vatPreview: null,
  vatPreviewInProgress: false,
  vatPreviewError: null,
  saveBillingDetailsInProgress: false,
  saveBillingDetailsError: null,
};

TransactionPanelComponent.propTypes = {
  getAccountLinkInProgress: bool,
  onFetchStripeAccount: func,
  onGetStripeConnectAccountLink: func,
  rootClassName: string,
  className: string,

  currentUser: propTypes.currentUser,
  transaction: propTypes.transaction.isRequired,
  totalMessagePages: number.isRequired,
  oldestMessagePageFetched: number.isRequired,
  messages: arrayOf(propTypes.message).isRequired,
  initialMessageFailed: bool,
  savePaymentMethodFailed: bool,
  fetchMessagesInProgress: bool.isRequired,
  fetchMessagesError: propTypes.error,
  sendMessageInProgress: bool.isRequired,
  sendMessageError: propTypes.error,
  stagedAttachments: array,
  offerStagedAttachments: array,
  onUploadOfferAttachment: func.isRequired,
  onRemoveOfferAttachment: func.isRequired,
  onSeedOfferAttachments: func.isRequired,
  onClearOfferAttachments: func.isRequired,
  downloadAttachmentInProgressIds: arrayOf(string),
  downloadAttachmentError: propTypes.error,
  onDownloadReceipt: func,
  downloadReceiptInProgressId: string,
  downloadReceiptFailedId: string,
  onUploadAttachment: func.isRequired,
  onRemoveAttachment: func.isRequired,
  onDownloadAttachment: func.isRequired,
  onOpenAttachment: func.isRequired,
  onFetchAttachmentPreview: func.isRequired,
  attachmentPreviewUrls: object,
  sendReviewInProgress: bool.isRequired,
  sendReviewError: propTypes.error,
  ownReview: object,
  onManageDisableScrolling: func.isRequired,
  onShowMoreMessages: func.isRequired,
  onSendMessage: func.isRequired,
  onSendReview: func.isRequired,
  onSubmitBookingRequest: func.isRequired,
  timeSlots: arrayOf(propTypes.timeSlot),
  fetchTimeSlotsError: propTypes.error,
  nextTransitions: array,

  // Sale related props
  onAcceptSale: func.isRequired,
  onDeclineSale: func.isRequired,
  acceptInProgress: bool.isRequired,
  declineInProgress: bool.isRequired,
  acceptSaleError: propTypes.error,
  declineSaleError: propTypes.error,

  // line items
  onFetchTransactionLineItems: func.isRequired,
  lineItems: array,
  fetchLineItemsInProgress: bool.isRequired,
  fetchLineItemsError: propTypes.error,

  // Profile update for dismissing onboarding tip
  onUpdateProfile: func,

  // Invoice billing path
  onAcceptOfferInvoice: func,
  acceptOfferInvoiceInProgress: bool,
  acceptOfferInvoiceError: propTypes.error,
  acceptCustomProOfferError: propTypes.error,
  onJobDoneInvoice: func,
  onAcceptJobInvoice: func,
  onJobDoneAcceptInvoice: func,
  onRequestInvoicing: func,
  onLookupInvoicingCompany: func,
  onClearInvoicingRequest: func,
  requestInvoicingInProgress: bool,
  requestInvoicingError: propTypes.error,
  requestInvoicingResult: object,
  lookupInvoicingCompanyInProgress: bool,
  lookupInvoicingCompanyError: propTypes.error,
  lookupInvoicingCompanyResult: object,

  // VAT preview (spec §5 "Preview and gates")
  vatPreview: object,
  vatPreviewInProgress: bool,
  vatPreviewError: propTypes.error,
  onFetchVatPreview: func,
  onSaveBillingDetails: func,
  saveBillingDetailsInProgress: bool,
  saveBillingDetailsError: propTypes.error,

  // from injectIntl
  intl: intlShape,
};

const TransactionPanel = injectIntl(withRouter(TransactionPanelComponent));

export default TransactionPanel;
